// extracted by mini-css-extract-plugin
module.exports = {"Workflow":"Workflow_Workflow__EtgaO","Content":"Workflow_Content__9XIq6"};